angular.module('TetherApp').controller('ClientContextController', [
    'clientUpdateService',
    function (clientUpdateService) {
        this.updateService = clientUpdateService;

        this.updateClientContext = function (data) {
            let callback = function() {
                window.location.href = "/launchpad";
            };
            this.updateService.setSelectedClient(data, callback);
        };
    }
]);
